import { render } from "./PlanManagement.vue?vue&type=template&id=129c51e4&scoped=true"
import script from "./PlanManagement.vue?vue&type=script&lang=js"
export * from "./PlanManagement.vue?vue&type=script&lang=js"

import "./PlanManagement.vue?vue&type=style&index=0&id=129c51e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129c51e4"]])

export default __exports__